/**
 * @fileoverview Routes each report type to its dedicated filter panel component.
 * @module pages/reports/ReportFilterPanels
 *
 * Keeps rendering logic minimal: report-type selection stays here while each
 * export option delegates to a focused panel via `reportFilterPanelRegistry`.
 */
import ReportTypeSelector from "./filterPanels/ReportTypeSelector.jsx";
import { resolveReportFilterPanel } from "./filterPanels/reportFilterPanelRegistry.js";

/** Renders the report-type selector and the panel that matches the current option. */
const ReportFilterPanels = (props) => {
  const { t, reportsOptions, selectedReportOption, handlers } = props;
  const optionValue = selectedReportOption?.value;
  // Lookup avoids a long conditional chain and keeps cyclomatic complexity low.
  const panelConfig = resolveReportFilterPanel(optionValue, props);
  const PanelComponent = panelConfig?.Component;

  return (
    <>
      <ReportTypeSelector
        t={t}
        reportsOptions={reportsOptions}
        selectedReportOption={selectedReportOption}
        onSelectReportOption={handlers.onSelectReportOption}
      />
      {PanelComponent ? <PanelComponent {...panelConfig.panelProps} /> : null}
    </>
  );
};

export default ReportFilterPanels;
